import Axios from 'axios'
import {
    LIST,
    LIST_FAILED,
    LIST_SUCCESSFUL,

}  from '../constant/listofemp'


export const listEmployees = (email, password) => async (dispatch) => {
    dispatch({
        type: LIST
    })

    const data = sessionStorage.getItem("userInfo");
    const authToken = JSON.parse(data)?.access;


    // console.log(authToken)


    try {
        const { data } = await Axios.get(`https://dev.goxsuite.com/api/v1/admin/list-employees`, {
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${authToken}`,
            },
        });
        

        dispatch({
            type: LIST_SUCCESSFUL,
            payload: data
        })

        console.log(data)

    }
    catch (error) {
        dispatch({
            type: LIST_FAILED,
            payload: error
        })
    }
}